import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';
import { messages } from './transplantHistory.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class TransplantHistoryDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    const relatedDonor = isNullOrWhiteSpace(this.props.transplantHistory.relatedDonorDisplay) ?
      this.props.transplantHistory.relatedDonor :
      this.props.transplantHistory.relatedDonorDisplay;

    return (
      this.props.transplantHistory.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'transplantHistory_' + this.props.transplantHistory.transplantType}>
        <div className="col-md-4 primary-data">
          {
            this.props.transplantHistory.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.transplantHistory.transplantType}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.startDate} />}
                value={this.props.transplantHistory.startDate} language={this.props.language}
                isDate
                isActive={this.configurationActive('StartDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.relatedDonor} />}
                value={relatedDonor} language={this.props.language}
                isActive={this.configurationActive('RelatedDonor')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerName} />}
                value={this.props.transplantHistory.providerName} language={this.props.language}
                isActive={this.configurationActive('ProviderName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.transplantHistory.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.transplantHistory.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.transplantHistory.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.transplantHistory.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="transplantHistory_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.transplantHistory.nullMessage}
        </div>
      </div>
    );
  }
}

TransplantHistoryDetail.propTypes = {
  transplantHistory: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
